import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useProvidedAuth } from './useProvidedAuth';
import { WorkshopPageParams } from './WorkshopPageParams';
import { WorkshopTypes } from './WorkshopTypes';

type WorkshopTvViewHook = {
  isTvView: boolean | undefined;
  id: string;
  type: WorkshopTypes;
}

export enum Centers {
  GRANOLLERS = 'GRANOLLERS_WORKSHOP',
  MATARO = 'MATARO_WORKSHOP',
}

export const useWorkshopTvView = (): WorkshopTvViewHook => {
  const { user } = useProvidedAuth();
  const { id, type } = useParams<WorkshopPageParams>();
  const [isTvView, setisTVView] = useState<boolean>();

  useEffect(() => {
    if (!user && !!id && !!type) {
      setisTVView(true);
    } else if (user) {
      setisTVView(false);
    }
  }, [user, id, type]);

  return {
    id,
    isTvView,
    type,
  };
};
